import request from '@/utils/request';

export function KsTeamCollectApi() {
    return{
        // 快手团队数据-列表
        getKsTeamCollectList: params => {
            return request({
                url: '/admin/index/ks_team_collect',
                method: 'get',
                params,
            });
        },
        // 快手团队数据-详情
        getKsTeamCollectDetail: params => {
            return request({
                url: '/admin/index/ks_team_collect_detail',
                method: 'get',
                params,
            });
        },
    }
}